<template>
  <div
    class="DetailPromos">
    <!-- BUILD ON DOMO -->
    <div
      class="DetailPromos_Promo">
      <h3>
        Build on the Domo platform.
      </h3>
      <p
        class="py-1">
        Build apps for your unique business needs on the foundation of Domo's server-less platform.
      </p>
      <BaseButton
        class="mt-1"
        theme="orange"
        block
        href="https://www.domo.com/platform/build">
        LEARN MORE
      </BaseButton>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'DetailPromos',

  components: {
    BaseButton,
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.DetailPromos_Promo + .DetailPromos_Promo {
  margin-top: 24px;
  padding-top: 24px;
  border-top: $border;
}
</style>
